/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-get, ember/require-computed-property-dependencies, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import EmberObject, { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import GoalState from '@linc-technologies/linced-common/enums/goal-state';
import { rollbackRecord } from '@linc-technologies/linced-common/utils/record-rollback';

export default class GoalPicker extends Component {
  // Services
  @service
  paperToaster;

  @service
  router;

  @service
  session;

  @service
  store;

  @tracked
  editingGoal = null;

  @tracked
  goalSubcategory = null;

  @action
  setGoalSubcategory(value) {
    this.goalSubcategory = value;
  }

  @tracked
  goalText = null;

  @action
  setGoalText(value) {
    this.goalText = value;
  }

  @tracked
  goalCategory;

  @tracked
  goalDialogOpen;

  @tracked
  selectedCategory;

  @action
  setSelectedCategory(value) {
    this.selectedCategory = value;
  }

  @tracked
  subject;

  onSave() {}

  @computed('states.@each.awarded', 'goals.@each.id')
  get progressData() {
    let states = this.states;
    let goals = this.goals;
    let categories = this.categories;
    let progress = [];

    categories.forEach((category) => {
      let data = EmberObject.create({
        categoryId: category.id,
        total: 0,
        developing: 0,
        secure: 0,
      });
      goals
        .filter((goal) => goal.category_id === category.id)
        .forEach((goal) => {
          let state = states.find((s) => s.goal_id === goal.id);
          data.incrementProperty('total');
          if (state) {
            switch (state.get('awarded')) {
              case GoalState.DEVELOPING:
                data.incrementProperty('developing');
                break;
              case GoalState.SECURE:
                data.incrementProperty('secure');
                break;
            }
          }
        });
      let total = data.get('total');
      if (total > 0) {
        data.set('securePercent', (data.get('secure') / total) * 100);
        data.set(
          'developingPercent',
          (data.get('developing') / total) * 100 + data.get('securePercent'),
        );
      }
      progress.push(data);
    });

    return progress;
  }

  @action
  onStateChange() {
    if (this.states) {
      this.states.update();
    }
  }

  @action
  setSubject(subject) {
    this.subject = subject;
  }

  @action
  addGoal(category) {
    this.resetGoal();
    this.goalCategory = category;
    this.goalDialogOpen = true;
  }

  @action
  closeGoalDialog() {
    this.goalDialogOpen = false;
  }

  @action
  saveGoal() {
    let goal = this.editingGoal;
    let toaster = this.paperToaster;

    if (isEmpty(goal)) {
      let category = this.goalCategory;
      let subcategory = this.goalSubcategory;
      let sequence =
        (isEmpty(subcategory)
          ? category.get('goals.length')
          : subcategory.get('goals.length')) + 1;
      goal = this.store.createRecord('goals/goal', {
        schoolId: this.get('session.school'),
        authorId: this.get('session.person'),
        isPLP: true,
        personId: this.get('session.person'),
        categoryId: category,
        sequence,
      });
    }

    goal.setProperties({
      subcategoryId: this.goalSubcategory,
      label: this.goalText,
      educatorDescription: this.goalText,
      peopleDescription: this.goalText,
    });

    goal
      .save()
      .then(() => {
        this.goalDialogOpen = false;
        this.onSave();
        toaster.show(`Goal "${goal.get('label')}" saved.`, {
          duration: 4000,
          position: 'top right',
        });
      })
      .catch(() => {
        // Unload a new record and revert an edited one; the form keeps the input.
        rollbackRecord(goal);
        toaster.show(`Error saving goal.`, {
          duration: 4000,
          position: 'top right',
        });
      });
  }

  resetGoal() {
    this.editingGoal = null;
    this.goalText = '';
    this.goalSubcategory = null;
  }
}
